var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container } from '@mui/material';
import { FlexCol, FlexRow, isLocalhost } from '@xyo-network/sdk-xyo-react-js';
import { WindowSize } from '../components';
import { Copyright, FooterLinks, FooterLogo } from './components';
import FooterMenus from './menus';
const Footer = (_a) => {
    var { children, transparent = false, container = 'lg', menus = true } = _a, props = __rest(_a, ["children", "transparent", "container", "menus"]);
    return (_jsx(FlexRow, Object.assign({ background: !transparent }, props, { children: _jsx(Container, Object.assign({ maxWidth: container }, { children: _jsxs(FlexCol, Object.assign({ component: "footer", padding: 2 }, { children: [_jsx(FooterLogo, { display: "flex", padding: 2 }, void 0), children, menus ? _jsx(FooterMenus, { paddingY: 2 }, void 0) : null, _jsx(Copyright, { paddingX: 2 }, void 0), _jsx(FooterLinks, { paddingY: 2 }, void 0), isLocalhost ? _jsx(WindowSize, {}, void 0) : null] }), void 0) }), void 0) }), void 0));
};
export default Footer;
//# sourceMappingURL=Footer.js.map